import React, { createContext, useContext, useState } from 'react';
import type { ArticleCategory } from '@/types/articles';

interface ArticleCategoryContextType {
  isOpen: boolean;
  editingCategory: ArticleCategory | null;
  openAddCategory: () => void;
  openEditCategory: (category: ArticleCategory) => void;
  closeCategoryDialog: () => void;
}

const ArticleCategoryContext = createContext<ArticleCategoryContextType | undefined>(undefined);

export const ArticleCategoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState<ArticleCategory | null>(null);

  const openAddCategory = () => {
    setEditingCategory(null);
    setIsOpen(true);
  };

  const openEditCategory = (category: ArticleCategory) => {
    setEditingCategory(category);
    setIsOpen(true);
  };

  const closeCategoryDialog = () => {
    setIsOpen(false);
    setEditingCategory(null);
  };

  return (
    <ArticleCategoryContext.Provider 
      value={{ 
        isOpen, 
        editingCategory, 
        openAddCategory, 
        openEditCategory, 
        closeCategoryDialog 
      }}
    >
      {children}
    </ArticleCategoryContext.Provider>
  );
};

export const useArticleCategoryDialog = () => {
  const context = useContext(ArticleCategoryContext);
  if (context === undefined) {
    throw new Error('useArticleCategoryDialog must be used within an ArticleCategoryProvider');
  }
  return context;
};
